/* Sales · Demo Links page — wraps the shared SandboxLinkGenerator.
 *
 * iter98.93 — Sales reps generate demo links to send to prospect
 * doctors as part of outbound. This page lists every link they've
 * minted (with claim counts + conversion stats) plus the composer.
 */
import React from "react";
import SandboxLinkGenerator from "@/components/sandbox/SandboxLinkGenerator";

export default function SalesDemoLinks() {
    return (
        <div className="space-y-4 max-w-5xl">
            <div>
                <div className="text-[10px] tracking-[0.22em] font-bold uppercase text-primary">
                    Outbound · Demo links
                </div>
                <h1 className="font-display text-2xl sm:text-3xl font-bold mt-1 tracking-tight">
                    Send a Invisique™ sandbox to your prospects
                </h1>
                <p className="text-[13px] text-muted-foreground mt-1 leading-relaxed max-w-3xl">
                    A demo link drops your prospect into a fully-functional Invisique™ provider portal — pre-seeded with patients and cases — without making them sign up. You see who claimed each link so you can follow up.
                </p>
            </div>
            <SandboxLinkGenerator
                title="Your demo links"
                description="Generate as many as you need. Each link expires in 7 days and captures the visitor's name, email, and phone on claim — perfect for follow-up calls."
            />
        </div>
    );
}
